import { Link } from "react-router-dom";
import { ChevronRight, Home } from "lucide-react";

const Breadcrumbs = ({ items }) => {
  if (!items || items.length === 0) return null;

  const allItems = [{ label: "Home", href: "/" }, ...items];

  return (
    <nav
      aria-label="Breadcrumb"
      className="bg-slate-50 border-b border-slate-200"
      data-testid="breadcrumbs"
    >
      <div className="container-max px-4 sm:px-6 lg:px-8">
        <ol className="flex items-center gap-1.5 py-3 text-sm overflow-x-auto">
          {allItems.map((item, index) => {
            const isLast = index === allItems.length - 1;
            return (
              <li key={item.href || item.label} className="flex items-center gap-1.5 whitespace-nowrap">
                {index > 0 && (
                  <ChevronRight className="w-3.5 h-3.5 text-slate-400 flex-shrink-0" />
                )}
                {isLast ? (
                  <span className="text-slate-600 font-medium" aria-current="page">
                    {index === 0 && <Home className="w-3.5 h-3.5 inline mr-1" />}
                    {item.label}
                  </span>
                ) : (
                  <Link
                    to={item.href}
                    className="text-slate-500 hover:text-[#FF5A1F] transition-colors"
                  >
                    {index === 0 && <Home className="w-3.5 h-3.5 inline mr-1" />}
                    {item.label}
                  </Link>
                )}
              </li>
            );
          })}
        </ol>
      </div>
    </nav>
  );
};

export default Breadcrumbs;

export const generateBreadcrumbSchema = (items) => {
  const allItems = [{ label: "Home", href: "/" }, ...items];
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: allItems.map((item, index) => ({
      "@type": "ListItem",
      position: index + 1,
      name: item.label,
      item: `https://www.hitechtransit.com${item.href || ""}`,
    })),
  };
};
